import React, { memo, useCallback } from "react";
import { EditorToolbar } from "../../../react/EditorToolbar/EditorToolbar";
import { EditorToolbarButton } from "../../../react/EditorToolbarButton/EditorToolbarButton";
import { EditorToolbarDivider } from "../../../react/EditorToolbarDivider/EditorToolbarDivider";
import { languages, notWrapTitle, removeCodeBlockTitle, wrapLinesTitle, } from "../constants";
export const EditorCodeMenu = memo(function EditorCodeMenu({ languageName, lineWrapping, onLanguageChange, onLineWrappingChange, onRemove, }) {
    const handleChange = useCallback((event) => {
        onLanguageChange(languages.find((lang) => lang.name === event.target.value));
    }, [onLanguageChange]);
    const handleLineWrapClick = useCallback((event) => {
        event.preventDefault();
        onLineWrappingChange(true);
    }, [onLineWrappingChange]);
    const handleNotWrapClick = useCallback((event) => {
        event.preventDefault();
        onLineWrappingChange(false);
    }, [onLineWrappingChange]);
    const handleRemove = useCallback((event) => {
        event.preventDefault();
        onRemove();
    }, [onRemove]);
    return (React.createElement(EditorToolbar, null,
        React.createElement("select", { className: "editor-code-menu__select", value: languageName, onChange: handleChange }, languages.map((lang) => (React.createElement("option", { key: lang.name, value: lang.name }, lang.label)))),
        React.createElement(EditorToolbarDivider, null),
        React.createElement(EditorToolbarButton, { icon: "wrap-text-no", title: notWrapTitle, color: "blue", light: true, active: !lineWrapping, onMouseDown: handleNotWrapClick }),
        React.createElement(EditorToolbarButton, { icon: "wrap-text", title: wrapLinesTitle, color: "blue", light: true, active: lineWrapping, onMouseDown: handleLineWrapClick }),
        React.createElement(EditorToolbarButton, { icon: "trash-duotone", iconSize: "S", title: removeCodeBlockTitle, color: "red", light: true, kind: "bg", onMouseDown: handleRemove })));
});
